import { render, staticRenderFns } from "./ModalCustomerEdit.vue?vue&type=template&id=885f0fca&scoped=true"
import script from "./ModalCustomerEdit.vue?vue&type=script&lang=js"
export * from "./ModalCustomerEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalCustomerEdit.vue?vue&type=style&index=0&id=885f0fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885f0fca",
  null
  
)

export default component.exports